// extracted by mini-css-extract-plugin
export default {"bottles_wrapper":"Bottles_bottles_wrapper__PI4pg","bottles_header":"Bottles_bottles_header__it-Oq","bottles_items":"Bottles_bottles_items__HtW-f"};